import Icd10Codes from './Icd10Codes';

export default Icd10Codes;
